import { CaseColumnKeys } from '../utils/caseColumnKeys'

export const HOME_RATING_COLUMN_KEY = CaseColumnKeys.OwnerNps

const HOME_RATING_COLUMN_KEYS: string[] = [
  CaseColumnKeys.OwnerNps,
  CaseColumnKeys.GuestNps,
  CaseColumnKeys.GuestAirbnbRating,
  CaseColumnKeys.GuestVrboRating,
]

const ENRICHMENT_COLUMN_KEYS: string[] = [
  CaseColumnKeys.ValueAddedServices,
  CaseColumnKeys.RevenueModel,
  CaseColumnKeys.OpenCases,
  CaseColumnKeys.PropertyStatus,
  CaseColumnKeys.BookingRating,
]

export const getEnrichmentColumnKeys = (columnKeys: string[]) => {
  const enrichmentColumnKeys = columnKeys.filter(columnKey =>
    ENRICHMENT_COLUMN_KEYS.includes(columnKey),
  )
  if (columnKeys.some(columnKey => HOME_RATING_COLUMN_KEYS.includes(columnKey))) {
    enrichmentColumnKeys.push(HOME_RATING_COLUMN_KEY)
  }
  return enrichmentColumnKeys.sort()
}
